module.exports = {
  ACCOUNT: {
    EMAIL_CONFIRMATION: 'accountEmailConfirmation',
    ETH:'accounteth',
    IS_ARTIST: 'accountisartist',
    SIGNED_IN: 'accountsignedin',
    STUDIOS: 'accountstudios',
    SUBSCRIBED_STUDIOS: 'accountsubscribedstudios',
    RESET: 'accountreset'
  },
  ARTIST: {
    CURRENT_ARTIST: 'artistcurrentartist',
  },
  ASSET: {
    CURRENT_ALBUM: 'assetcurrentalbum',
    CURRENT_ASSET: 'assetcurrentasset',
    CURRENT_ASSETS: 'assetcurrentassets',
    CURRENT_ISSUE: 'assetcurrentissue',
    SET: 'assetsset',
  },
  CHAT: {
    ADD: 'chatadd',
    SET: 'chatset',
    SET_CURRENT_AVAILABLE_THOUGHTS: 'chatsetcurrentavailablethoughts',
    SET_CURRENT_COLLABORATOR: 'chatsetcurrentcollaborator',
    SET_ROOM_ID: 'chatroomid',
    SET_SESSION_ID: 'chatsetsessionid',
    MEDIA_SELECTED: 'chatvideoselected'
  },
  CREDITS: {
    ACCRUED_CREDITS: 'creditsaccruedcredits',
    CURRENT_ARTIST_CREDITS: 'creditscurrentartistcredits',
    CURRENT_CREDITS: 'creditscurrentcredits',
    CURRENT_PROMOTIONAL_CREDITS: 'creditscurrentpromotionalcredits',
    CREDIT_PLAY_TIME: 'creditscreditplaytime',
    RESET: 'creditsreset'
  },
  DISPLAY: {
    ALLOW_SWIPE: 'displayallowswipe',
    CONTAIN_DISPLAY: 'displaycontaindisplay',
    CONTINUOUS_PLAY: 'displaycontinuousplay',
    REACTOR_PLAY: 'displayreactorplay',
    SHOW_SEARCH: 'displayshowsearch',
    TRANSACTION_IN_PROGRESS:'displaytransactioninprogress'
  },
  EMAIL: {
    ALBUM_NAME: 'emailalbumname',
    ASSET_ID: 'emailassetid',
  },
  FETCH: {
    CATEGORY_MODE: 'fetchcategorymode',
    FETCH_IN_PROGRESS: 'fetchfetchinprogress',
    FETCH_START: 'fetchfetchstart',
    QUERY: 'fetchquery',
    REFETCH_MESSAGE_ID: 'fetchrefetchmessageid',
  },
  HELP: {
    SHOW_AI_SIGN_IN: 'helpsetshowaisignin',
    SHOW_AI_WELCOME: 'helpshowaiwelcome',
    SHOW_ANNOYING_CONSENT: 'helpshowannoyingconsent',
    SHOW_PREVIEWS_WELCOME: 'helpshowpreviewswelcome',
    SHOW_PROFILE_HELP: 'helpshowprofilehelp',
    SHOW_WELCOME: 'helpshowwelcome',
  },
  HARMONIZE: {
    CREATE_POST: 'harmonizecreatepost',
    LIKED_PLAYLIST_INDEX: 'harmonizelikedplaylistindex',
    PLAY_CURRENT_SONG: 'harmonizeplaycurrentsong',
    POST_BUY_CREDITS_PAGE: 'harmonizepostbuycreditspage',
    POST_SIGN_IN_PAGE: 'harmonizepostsigninpage',
    RESET: 'harmonizereset',
    SET_COLLECTIONS: 'harmonizesetcollections',
    SET_CURRENT_COLLECTION: 'harmonizesetcurrentcollection',
    SET_ENGAGED: 'harmonizesetengaged',
    SET_FORCE_SIGN_IN: 'harmonizeforcesignin',
    SET_FULLSCREEN: 'harmonizesetfullscreen',
    SET_HIDE_OVERLAY: 'harmonizesethideoverlay',
    SET_LAST_PREVIEW_WARNING: 'harmonizesetlastpreviewwarning',

    SET_PLAYLIST_INDEX: 'harmonizesetplaylistindex',
    SET_PLAYER_MODE: 'harmonizesetplayermode',
    SET_PLAYER_STATE: 'harmonizesetplayerstate',
    SET_PLAY_TIME: 'harmonizesetplaytime',

    SET_SHOW_AI: 'harmonizesetshowai',
    SET_SHOW_ATTACHMENTS: 'harmonizeshowattachments',
    SET_SHOW_CHAT: 'harmonizesetshowchat',
    SET_SHOW_COLLECTIONS: 'harmonizeshowcollections',
    SONG_BLOCK: 'harmonizesongblock',
    SOUND: 'harmonizesound'
  },
  LOG: {
    ADD_LOG_MESSAGE: 'logaddlogmessages',
    RESET: 'logreset'
  },
  MESSAGES: {
    ADD: 'messagesadd',
    ADD_COMMENT: 'messagesaddcomment',
    DELETE: 'messagesdelete',
    DELETE_COMMENT: 'messagesdeletecomment',
    END_OF_MESSAGES: 'messagesendofmessages',
    PLAYLIST: 'messagesplaylist',
    GET: 'messagesget',
    SET: 'messagesset',
    SET_CHANNEL: 'messagessetchannel',
    SET_ROOM: 'messagessetroom',
    SET_ROOM_OWNER: 'messagessetroomowber',
    UPDATE: 'messagesupdate',
  },
  NFT:{
    CURRENT_ISSUE:'nftcurrentissue',
    DESCRIPTION:'nftdescription',
    MEDIA_HASH:'nftmediahash',
    MESSAGE:'nftmessage',
    MESSAGE_ID:'nftmessageid',
    MINT_ROYALTY:'nftmintroyalty',
    MINT_STAGE:'nftmintstage',
    NAME:'nftname',
    PRICE:'nftprice',
    RESET:'nftreset',
    TOKEN_ID:'nfttokenid',
    UPDATE:'nftupdate'
  },
  PLAYER_CONTROLS: {
    HIDE_CONTROLS: 'playercontrolshidecontrols',
    MEDIA_DURATION: 'playercontrolsmediaduration',
    MUTED: 'playercontrolsmuted',
    PLAYING: 'playercontrolsplaying',
    PREVIEW: 'playercontrolspreview',
    RESET: 'playercontrolsreset',
    USER_INTERACTED: 'playercontrolsuserinteracted',
    USER_STARTED_PLAYBACK: 'playercontrolsuserstartedplayback',
    USER_MUTED_MEDIA: 'playercontrolsmediaplamuted',
    USER_PAUSED_MEDIA: 'playercontrolsmediapaused',
    VIDEO_PLAYING: 'playercontrolsvideoplaying'
  },
  PURCHASE: {
    CREDITS_TO_PURCHASE: 'purchasecreditstopurchase',
    PRICING_TABLE: 'purchasepricingtable',
    SET_TRANSACTION_TYPE: 'purchasesettransactiontype',
  },
  REACTOR: {
    CURRENT_PLAY_TIME: 'reactorcurrentplaytime'
  },
  SETTINGS: {
    CONTROL_COLUMN_OPACITY: 'settingscontrolcolumnopacity',
    CURRENCY: 'settingscurrency',
    SET: 'settingsset',
    SHOW_ETH_IN_CURRENCY: 'settingsshowethincurrency',
    SHOW_MINTING_DEFAULTS: 'settingsshowmintingdefaults',
  },
  SONG: {
    CREATED_AT: 'songcreatedat',
    DESCRIPTION: 'songdescription',
    GENRE: 'songgenre',
    LYRICS: 'songlyrics',
    MEDIA: 'songmedia',
    MEDIA_ICONS: 'songmediaicons',
    RESET: 'songreset',
    SUMMARY: 'songsummary',
    TITLE: 'songtitle',
    UPDATED_AT: 'songupdatedat'
  },
  SHORT: {
    CAPTION: 'shortcaption',
    CLIP_END: 'shortclipend',
    CLIP_START: 'shortclipstart',
    DESCRIPTION: 'shortdescription',
    IMAGE: 'shortimage',
    MEDIA_ICONS: 'shortmediaicons',
    MESSAGE_ID: 'shortmessageid',
    RESET: 'shortreset',
    ROOM_ID: 'shortroomid',
    SUMMARY: 'shortsummary'
  }
}
